module.exports = __webpack_public_path__ + "img/file.fd913f5f.svg";